var $cd9e2abd0d06c7b4$exports = {};
$cd9e2abd0d06c7b4$exports = {
    "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};


export {$cd9e2abd0d06c7b4$exports as default};
//# sourceMappingURL=ru-RU.module.js.map
